import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    Embed,
    EmbedContent,
    Invitation,
    Invitations,
    Title,
    TitleSymbol,
    Wrapper,
} from './ConferenceInvitations.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceInvitationsTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.INVITATIONS}`}>
            <Title colors={colors}>
                {t('conference.component.videoInventions.title')}
                <TitleSymbol colors={colors} />
            </Title>

            {conf?.conference?.video_invitations?.length > 0 && (
                <>
                    <>
                        <Invitations>
                            {conf?.conference?.video_invitations?.map((item, index) => (
                                <Invitation key={`${index}`}>
                                    <EmbedContent>
                                        <Embed src={item?.url} title="Invite video" allowFullScreen></Embed>
                                    </EmbedContent>
                                </Invitation>
                            ))}
                        </Invitations>
                    </>
                </>
            )}
        </Wrapper>
    );
};

export default ConferenceInvitationsTemplate;
